import { render, staticRenderFns } from "./AdvTitledList.vue?vue&type=template&id=1afaf473&scoped=true&"
import script from "./AdvTitledList.vue?vue&type=script&lang=js&"
export * from "./AdvTitledList.vue?vue&type=script&lang=js&"
import style0 from "./AdvTitledList.vue?vue&type=style&index=0&id=1afaf473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afaf473",
  null
  
)

export default component.exports